import API from "@/models/API";
import router from "@/routes"

let storesType = () => ((router?.history.current.path||'').split('/')||[])[2] == 'storePanel' ? 'stores':'companies'
    

export default class SubscriptionProduct {

    constructor(item = {}) {
        this.subscription_product_id = item.subscription_product_id || null;
        this.subscription_product_type_id = item.subscription_product_type_id || null;
        this.credit_option_id = item.credit_option_id || null;
        this.name = item.name || {
            el: "",
            en: "",
            it: ""
        };
        this.description = item.description || {
            el: "",
            en: "",
            it: ""
        };
        this.store_ids = item.store_ids || [];
        this.stores = item.stores || [];
        this.variant_ids = item.variant_ids || [];
        this.variants = item.variants || [];
        this.visibility  = item.visibility  || false;
        this.image_url = item.image_url || "";
    }

    static getProducts = (q='') =>
    API.get(
        `/${storesType()}/${localStorage.getItem("storeId")}/subscriptions/products${q}`
    );

    static createProduct = (body) =>
    API.post(
        `/${storesType()}/${localStorage.getItem("storeId")}/subscriptions/products`, body
    );

    static updateProduct = (id,body) =>
    API.put(
        `/${storesType()}/${localStorage.getItem("storeId")}/subscriptions/products/${id}`, body
    );

    static deleteProduct = (id) =>
    API.put(
        `/${storesType()}/${localStorage.getItem("storeId")}/subscriptions/products/${id}`
    );

    static getProductsTypes = () =>
    API.get(
        `/${storesType()}/${localStorage.getItem("storeId")}/subscriptions/products/types`
    );

    static uploadImage = (id, image) =>
        API.post(
           `/${storesType()}/${localStorage.getItem("storeId")}/subscriptions/products/${id}/image`,
            image
        );


        static getCredits = () =>
            API.get(
                `/${storesType()}/${localStorage.getItem("storeId")}/subscriptions/products/credits`
            );
        
            static getCreditOptions = () =>
            API.get(
                `/${storesType()}/${localStorage.getItem("storeId")}/subscriptions/products/credit-options`
            );
                
}
